//VIEW PENDING LABS
export const GET_LABS_LIST_REQUEST = "GET_LABS_LIST_REQUEST"
export const GET_LABS_LIST_SUCCESS = "GET_LABS_LIST_SUCCESS"
export const GET_LABS_LIST_FAIL = "GET_LABS_LIST_FAIL"
export const GET_BLOCKED_LIST_REQUEST = "GET_BLOCKED_LIST_REQUEST"
export const GET_BLOCKED_LIST_SUCCESS = "GET_BLOCKED_LIST_SUCCESS"
export const GET_BLOCKED_LIST_FAIL = "GET_BLOCKED_LIST_FAIL"
//VIEW ALL VERIFIED LABS
export const GET_ALLLABS_LIST_REQUEST = "GET_ALLLABS_LIST_REQUEST"
export const GET_ALLLABS_LIST_SUCCESS = "GET_ALLLABS_LIST_SUCCESS"
export const GET_ALLLABS_LIST_FAIL = "GET_ALLLABS_LIST_FAIL"
//BLOCK LAB
export const DELETE_LAB_REQUEST = "DELETE_LAB_REQUEST"
export const DELETE_LAB_SUCCESS = "DELETE_LAB_SUCCESS"
export const DELETE_LAB_FAIL = "DELETE_LAB_FAIL"
export const UNBLOCK_LAB_REQUEST = "UNBLOCK_LAB_REQUEST"
export const UNBLOCK_LAB_SUCCESS = "UNBLOCK_LAB_SUCCESS"
export const UNBLOCK_LAB_FAIL = "UNBLOCK_LAB_FAIL"
export const GET_REVIEWS_REQUEST = "GET_REVIEWS_REQUEST"
export const GET_REVIEWS_SUCCESS = "GET_REVIEWS_SUCCESS"
export const GET_REVIEWS_FAIL = "GET_REVIEWS_FAIL"
export const GET_EQA_REQUEST = "GET_EQA_REQUEST"
export const GET_EQA_SUCCESS = "GET_EQA_SUCCESS"
export const GET_EQA_FAIL = "GET_EQA_FAIL"
//DELETE LAB
export const DELETEP_LAB_REQUEST = "DELETEP_LAB_REQUEST"
export const DELETEP_LAB_SUCCESS = "DELETEP_LAB_SUCCESS"
export const DELETEP_LAB_FAIL = "DELETEP_LAB_FAIL"
//GET SINGLE LAB
export const GET_LAB_REQUEST = "GET_LAB_REQUEST"
export const GET_LAB_SUCCESS = "GET_LAB_SUCCESS"
export const GET_LAB_FAIL = "GET_LAB_FAIL"
//UPDATE SINGLE LAB
export const UPDATE_LAB_REQUEST = "UPDATE_LAB_REQUEST"
export const UPDATE_LAB_SUCCESS = "UPDATE_LAB_SUCCESS"
export const UPDATE_LAB_FAIL = "UPDATE_LAB_FAIL"

//GET LAB DETAILS
export const GET_LAB_DETAIL = "GET_LAB_DETAIL";
export const GET_LAB_DETAIL_SUCCESS = "GET_LAB_DETAIL_SUCCESS";
export const GET_LAB_DETAIL_FAIL = "GET_LAB_DETAIL_FAIL";
//UPLOAD IMAGE
export const UPLOAD_REQUEST = 'UPLOAD_REQUEST';
export const UPLOAD_PROGRESS = 'UPLOAD_PROGRESS';
export const UPLOAD_SUCCESS =  'UPLOAD_SUCCESS';
export const UPLOAD_FAILURE = 'UPLOAD_FAILURE';
//VERIFY LAB
export const VERIFY_LAB_REQUEST = "VERIFY_LAB_REQUEST"
export const VERIFY_LAB_SUCCESS = "VERIFY_LAB_SUCCESS"
export const VERIFY_LAB_FAIL = "VERIFY_LAB_FAIL"